import { render, staticRenderFns } from "./SchoolFacialTeacherAvailableTable.vue?vue&type=template&id=30295a4d&scoped=true&"
import script from "./SchoolFacialTeacherAvailableTable.vue?vue&type=script&lang=js&"
export * from "./SchoolFacialTeacherAvailableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30295a4d",
  null
  
)

export default component.exports